import {Button} from '@mui/material';
import React from 'react';
import {Card, CenteredTypography, Section} from './CardStyles';
import {COLORS} from '@fupa/fupa-uikit';
import {Send} from '@mui/icons-material';

const SupportCard = () => {
  return (
    <Section backgroundColor={COLORS.lighterGrey}>
      <Card>
        <CenteredTypography variant='headline2' component='h2'>
          Support
        </CenteredTypography>
        <CenteredTypography variant='subheading' component='p'>
          Du hast Probleme beim Einbauen des Widgets?
          <br /> Die Sektion "FAQs - Häufig gestellte Fragen" beantworten dein Anliegen nicht oder du hast Feedback?
          <br />
          Dann schreibe uns eine Nachricht und wir versuchen dir weiterzuhelfen.
        </CenteredTypography>
        <p />
        <Button
          endIcon={<Send />}
          variant='contained'
          component='a'
          href='https://support.fupa.net/support/tickets/new'>
          FuPa-Team kontaktieren
        </Button>
        <CenteredTypography color={COLORS.darkerGrey} variant='subheading' component='p'>
          <span>Wichtig: Link zum eingebauten Widget in der Nachricht mitschicken.</span>
          <br />
          <span>Wenn möglich auch das verwendete CMS (Content Management System) angeben.</span>
        </CenteredTypography>
      </Card>
    </Section>
  );
};

export default SupportCard;
